import React from 'react';
import KnowledgeRecommendationCard from '../../freestyle/discovery/DiscoveryKnowledgeCard';

export default function KnowledgeLibraryResultCard({
  result,
  onPreview,
  onAdd,
}) {
  return (
    <KnowledgeRecommendationCard
      result={result}
      kind="contexts"
      onPreview={onPreview}
      onAdd={onAdd}
    />
  );
}
